import { 
  VStack, 
  Skeleton, 
  HStack, 
  Box 
} from "@chakra-ui/react";

const AgendaLoader = () => {
  return (
    <VStack spacing={3} align="stretch">
      {/* Activity Cards */}
      <VStack spacing={3} align="stretch">
        {/* Activity Card 1 */}
        <Box bg="white" p={4} borderRadius="md" border="1px solid" borderColor="gray.200">
          <HStack justify="space-between" mb={3}>
            <HStack spacing={2}>
              <Skeleton height="24px" width="24px" borderRadius="md" />
              <Skeleton height="16px" width="120px" />
            </HStack>
            <Skeleton height="20px" width="60px" />
          </HStack>
          <Skeleton height="16px" width="200px" mb={2} />
          <Skeleton height="12px" width="150px" />
        </Box>

        {/* Activity Card 2 */}
        <Box bg="white" p={4} borderRadius="md" border="1px solid" borderColor="gray.200">
          <HStack justify="space-between" mb={3}>
            <HStack spacing={2}>
              <Skeleton height="24px" width="24px" borderRadius="md" />
              <Skeleton height="16px" width="100px" />
            </HStack>
            <Skeleton height="20px" width="60px" />
          </HStack>
          <Skeleton height="16px" width="180px" mb={2} />
          <Skeleton height="12px" width="140px" />
        </Box>

        {/* Activity Card 3 */}
        <Box bg="white" p={4} borderRadius="md" border="1px solid" borderColor="gray.200">
          <HStack justify="space-between" mb={3}>
            <HStack spacing={2}>
              <Skeleton height="24px" width="24px" borderRadius="md" />
              <Skeleton height="16px" width="110px" />
            </HStack>
            <Skeleton height="20px" width="60px" />
          </HStack>
          <Skeleton height="16px" width="190px" mb={2} />
          <Skeleton height="12px" width="160px" />
        </Box>
      </VStack>
    </VStack>
  );
};

export default AgendaLoader;
